export default "__VITE_ASSET__7hCrAFvo__"